<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد استان
        </b-button>
      </b-col>
    </b-row>
    <div v-if="provinces">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage"  />
        <!-- <search ref="provincesSearchComponent" class="w-50" v-model="searchInput" /> -->
      </div>

      <b-card body-class="p-0" class="mt-1">
        <table-head ref="provincesTableHeadComponent" :items="tableHeadings" @sort="sort" />
        <b-row
          class="py-1 mx-1 border-bottom"
          v-for="province in provinces"
          :key="province.id"
        >
          <b-col class="d-flex align-items-center pl-0">
            {{ province.name }}
          </b-col>

          <b-col
            class="d-flex align-items-center flex-row-reverse"
            style="direction: ltr"
          >
            {{ new Date(province.created_at).toLocaleString('fa-IR', { timeZone: 'Iran' })}}
          </b-col>
          <b-col class="d-flex align-items-center">
            <b-button
              @click="showConfirmModal(province)"
              variant="flat-danger"
              class="font-weight-bolder"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
            <b-button
              @click="showFormModal(province)"
              variant="flat-secondary"
              class="font-weight-bolder"
            >
              <feather-icon icon="Edit2Icon" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <pagination ref="provincesPaginationComponent" v-model="page" :paginationData="paginationData" />
    </div>
    <b-sidebar
      width="500px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش استان" : "ایجاد استان" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
       
        <b-form-group class="mt-3">
          <label for="province_name" class="text-capitalize"
            >{{ $t("first name") }}:</label
          >
          <b-form-input
            id="province_name"
            v-model="provinceInput.name"
            type="text"
          />
        </b-form-group>
         <b-form-group class="mt-1">
          <label for="province_slug" class="text-capitalize"
            >اسلاگ| slug:</label
          >
          <b-form-input
            id="province_slug"
            v-model="provinceInput.slug"
            type="text"
          />
        </b-form-group>
         <b-form-group class="mt-1" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize">
            وضعیت :
          </label>
          <b-form-radio
            v-model="provinceInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            >فعال</b-form-radio
          >
          <b-form-radio
            v-model="provinceInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            >پیش نویس</b-form-radio
          >
        </b-form-group>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
   BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      provinces: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      provinceInput: {
        name: "",
        slug:"",
        status:"active"
       
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getProvinces();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getProvinces();
    },
    perPage(value) {
      this.page = 1;
      this.getProvinces();
    },
    page(value) {
      this.getProvinces();
    },
  },
  methods: {
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getProvinces();
    },

    async getProvinces() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate:true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/states",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.provinces = data.data;
          this.paginationData = data.meta;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showConfirmModal(province) {
      this.$bvModal
        .msgBoxConfirm(
          "آیا از حذف استان مطمئن هستید ؟" +
            `: ${province.name}.`,
          {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (confirmed) => {
          if (confirmed) {
            let provinceIndex = 0;
            this.provinces = await this.provinces.filter((provinceItem, index) => {
              if (provinceItem.id == province.id) {
                provinceIndex = index;
              }
              return provinceItem.id !== province.id;
            });

            const requestData = {
              method: "delete",
              url: `/admin/states/${province.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(
                  `استان: ${province.name} با موفقیت حذف شد.`,
                  {
                    title: this.$t("Done"),
                    variant: "success",
                    solid: true,
                  }
                );
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.provinces.splice(provinceIndex, 0, province);
              });
          }
        });
    },
    showFormModal(province) {
      if (province) {
        this.provinceInput = {
          id: province.id,
          name: province.name,
          slug:province.slug,
          status:province.status,
        
        };
        this.editMode = true;
      } else {
        this.provinceInput = {
          name: "",
          slug:"",
          status:"active",
        
        };
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
     
      if (!errorMessage && !this.provinceInput.name) {
        errorMessage = "لطفا نام استان را وارد کنید";
      }
      if (!errorMessage && this.provinceInput.name.length < 2) {
        errorMessage = "نام استان نمی تواند کمتر از دو کاراکتر باشد";
      }
      if (!errorMessage && !this.provinceInput.slug) {
        errorMessage = "لطفا اسلاگ استان را وارد کنید";
      }
       if (!errorMessage && this.provinceInput.slug.length < 2) {
        errorMessage = "اسلاگ استان نمی تواند کمتر از دو کاراکتر باشد";
      }
     

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode ? `/admin/states/${this.provinceInput.id}` : `/admin/states`,
        data: this.provinceInput,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "استان با موفقیت اضافه شد";
          if (this.editMode) message = "استان با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });
          if (!this.editMode && this.provinces && this.provinces.length > 0) {
            this.$refs.provincesPaginationComponent.clear();
            // this.$refs.provincesSearchComponent.clear();
            this.$refs.provincesTableHeadComponent.clear();
            this.page = 1;
            this.searchInput = "";
            this.sortBy = "";
            this.sortDir = "";
          }

          this.submitLoading = false;
          this.formModal = false;
          this.getProvinces();
        })
        .catch((err) => {
          let message = "خطا در ایجاد استان";
          if (this.editMode) message = "خطا در ویرایش استان";
          if (err.response && err.response.data && err.response.data.message)
            message = err.response.data.message;

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
  
   
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
